// Mock data for HHHotsauce e-commerce site

export const productData = {
  id: "batch-001",
  name: "Limited Batch #1",
  subtitle: "Ghost Pepper Pear & Peach Scorpion Heat",
  description: "Our first limited edition batch brings together Carolina Reaper, Ghost Pepper, Pears, and Peaches for an intense heat experience balanced with sweet, fruity undertones. This batch was intentionally crafted for medium heat to ensure everyone, even those with a low heat tolerance, can enjoy the complex flavors without overwhelming burn. This small-batch sauce is seed-to-sauce craft perfection.",
  price: 30.00,
  originalStock: 50,
  currentStock: 42,
  images: [
    "https://customer-assets.emergentagent.com/job_hhh-craft-heat/artifacts/zumqsj0f_first%20edited%20bottle.mp4",
    "https://customer-assets.emergentagent.com/job_hhh-craft-heat/artifacts/gf9v7u2h_bottle1.jpeg",
    "https://customer-assets.emergentagent.com/job_hhh-craft-heat/artifacts/bwnb438t_bottle1-1.jpeg",
    "https://customer-assets.emergentagent.com/job_hhh-craft-heat/artifacts/nfc1od1l_bottle1-2.jpeg",
    "https://customer-assets.emergentagent.com/job_hhh-craft-heat/artifacts/ai2a4kiz_bottle1-3.jpeg",
    "https://customer-assets.emergentagent.com/job_hhh-craft-heat/artifacts/mtdldok7_bottle1-4.jpeg"
  ],
  heatLevel: 6.5,
  pepperTypes: ["Carolina Reaper", "Ghost Pepper", "White Ghost Pepper"],
  flavorNotes: ["Pear", "Peach", "White Wine", "Honey", "Lime", "Vanilla"],
  ingredients: "White Ghost Peppers, Carolina Reapers, Pears, Peaches, White Onions, Sugar, Honey, Parsnips, Carrots, Vanilla Bean, Lime, White Vinegar, Salt, White Peppercorns, Coriander Powder, Mustard Powder, Cardamom, Mace, Ginger, Cornstarch, MSG",
  size: "150ml",
  warning: "CAUTION: Heat and Flavour - But Not For The Weak",
  shippingOptions: [
    {
      id: "local",
      name: "Local Pickup",
      price: 0,
      description: "Free local pickup"
    },
    {
      id: "canada-express",
      name: "Canada Xpresspost",
      price: 18.00,
      description: "With tracking, 1-3 business days (CAD)"
    },
    {
      id: "canada-standard",
      name: "Canada Standard",
      price: 8.00,
      description: "No tracking, 7-10 business days (CAD)"
    },
    {
      id: "usa",
      name: "USA Shipping",
      price: 20.00,
      description: "Standard shipping (USD)"
    }
  ]
};

export const reviewsData = [
  {
    id: 1,
    name: "Marcus T.",
    rating: 5,
    date: "2024-12-15",
    comment: "Holy heat! This sauce delivers exactly what it promises. The burn is intense but the peach and honey notes really come through. Not just hot for the sake of hot.",
    verified: true
  },
  {
    id: 2,
    name: "Sarah K.",
    rating: 5,
    date: "2024-12-10",
    comment: "Finally, a hot sauce that respects flavor as much as heat. The white wine and parsnip create this unique savory-sweet profile. I'm rationing my bottle until the next batch!",
    verified: true
  },
  {
    id: 3,
    name: "David R.",
    rating: 5,
    date: "2024-12-08",
    comment: "The endorphin rush is real. Used it on wings and could barely finish one. In a good way. The complexity of flavors is what sets this apart from every other super-hot sauce.",
    verified: true
  },
  {
    id: 4,
    name: "Jennifer L.",
    rating: 4,
    date: "2024-12-05",
    comment: "Definitely not for beginners, but if you're chasing that heat high, this is it. The peach sweetness helps balance the intense capsaicin. Would buy again.",
    verified: true
  }
];

export const instagramPosts = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?w=400&h=400&fit=crop",
    caption: "Fresh batch ready to bottle 🌶️",
    likes: 234
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1599639957043-f0f7ab7b7a8e?w=400&h=400&fit=crop",
    caption: "Carolina Reapers straight from the garden",
    likes: 189
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1534940519139-f860fb10f574?w=400&h=400&fit=crop",
    caption: "The perfect blend of heat and flavor",
    likes: 312
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1532336414038-cf19250c5757?w=400&h=400&fit=crop",
    caption: "Seed to sauce - every step matters",
    likes: 276
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1513639776629-7b61b0ac49cb?w=400&h=400&fit=crop",
    caption: "Heat with purpose",
    likes: 298
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1578474846511-04ba529f0b88?w=400&h=400&fit=crop",
    caption: "Limited edition means once it's gone, it's gone",
    likes: 356
  }
];

export const featuresData = [
  {
    title: "Limited Edition Batches",
    description: "Each batch is unique and will never be reproduced. Once sold out, it's gone forever. No mass production, no compromises.",
    icon: "flame"
  },
  {
    title: "Seed to Sauce",
    description: "We grow our own peppers and control every step of the process. From planting seeds to bottling sauce, it's all crafted by hand.",
    icon: "sprout"
  },
  {
    title: "High Heat, Real Flavor",
    description: "We use Carolina Reapers and Ghost Peppers for intense heat, but balance it with fruit, vinegar, and spices for complex, layered flavor.",
    icon: "fire"
  },
  {
    title: "Small Batch Craft",
    description: "Every bottle is hand-made in small quantities. We focus on quality over quantity, ensuring each batch meets our exacting standards.",
    icon: "package"
  }
];

export const heatLevels = [
  { level: 1, label: "Mild", color: "#90EE90" },
  { level: 2, label: "Gentle", color: "#FFD700" },
  { level: 3, label: "Warm", color: "#FFA500" },
  { level: 4, label: "Medium", color: "#FF8C00" },
  { level: 5, label: "Hot", color: "#FF6347" },
  { level: 6, label: "Very Hot", color: "#FF4500" },
  { level: 7, label: "Extreme", color: "#DC143C" },
  { level: 8, label: "Insane", color: "#B22222" },
  { level: 9, label: "Volcanic", color: "#8B0000" },
  { level: 10, label: "Inferno", color: "#4B0000" }
];

export const cartItems = [];
